import '@/styles/globals.css'
import '@/styles/rich-text.css'

import type { FC, ReactNode } from 'react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import { Instrument_Sans, Instrument_Serif, JetBrains_Mono } from 'next/font/google'
import { Toaster } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'

const sans = Instrument_Sans({
    subsets: ['latin', 'latin-ext']
})

const display = Instrument_Serif({
    subsets: ['latin', 'latin-ext'],
    weight: '400',
    style: ['normal', 'italic']
})

const mono = JetBrains_Mono({
    subsets: ['latin', 'latin-ext']
})

const fontVariables = `:root{--font-app-sans:${sans.style.fontFamily};--font-app-mono:${mono.style.fontFamily};--font-app-heading:${sans.style.fontFamily};--font-app-display:${display.style.fontFamily}}`

const App: FC<AppProps> = ({ Component, pageProps }): ReactNode => {
    return (
        <div className='h-full font-sans'>
            <Head>
                <style dangerouslySetInnerHTML={{ __html: fontVariables }} />
                <meta name='viewport' content='width=device-width, initial-scale=1' />
            </Head>

            <TooltipProvider>
                <Component {...pageProps} />
            </TooltipProvider>

            <Toaster theme='light' position='top-right' richColors />
        </div>
    )
}

export default App
